export default {
  PENDING: 'PENDING',
  FETCHED: 'FETCHED',
  NO_RESULT: 'NO_RESULT',
};
